import { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import { useT } from '../i18n';

interface State {
  error: Error | null;
}

function ErrorFallback({ error }: { error: Error }) {
  const t = useT();
  return (
    <div role="alert" className="flex flex-col items-center justify-center h-screen px-6 text-center bg-surface-panel">
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-surface-subtle text-ink-subtle mb-4">
        <AlertTriangle className="w-6 h-6" aria-hidden="true" />
      </div>
      <h1 className="text-base font-semibold text-ink-primary">{t('a-ui.somethingWrong')}</h1>
      <p className="mt-1 text-sm text-ink-muted max-w-md break-words">{error.message}</p>
      <Button className="mt-6" onClick={() => window.location.reload()}>
        {t('a-ui.reload')}
      </Button>
    </div>
  );
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Erro de renderização:', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return <ErrorFallback error={error} />;
  }
}
